import { SVGProps } from 'react';

const Framer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 16v7l-7-7V9h14V2H5l14 14zm-7 0h7"
    />
  </svg>
);
export default Framer;
